import React from 'react';
import { SpinnerIcon } from '../icons';

interface LoadingProps {
  className?: {
    spinner?: string;
    container?: string;
  };
}

function Loading({ className = {} }: LoadingProps) {
  return (
    <div
      className={` w-full flex justify-center  ${
        className?.container ?? 'h-screen'
      }`}
    >
      <div className="flex h-full opacity-70 z-30 pb-44  m-auto">
        <SpinnerIcon
          className={`m-auto w-24 h-24 animate-spin text-gray-200 fill-purple-300 ${
            className?.spinner ?? ''
          } `}
        />
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

export default Loading;
